import EditorMarkingRow from "./EditorMarkingRow";
import EditorSectionHeader from "../common/EditorSectionHeader";

const EditorFotoKendaraanSection = (props) => {
  const { isBerangkat, showBerangkat, setShowBerangkat, headerData } = props;

  // props shared by every marking row
  const common = props;

  // the trailer box photos (gambar_box_*) only apply when the header actually has a trailer - same condition
  // as the checklist's own Trailer card (EditorTrailerCheckList.js / TradoEditorTrailerCheckList.js)
  const hasTrailer = !!(headerData.trailer_id || headerData.data_trailer);

  return (
    <>
      <EditorSectionHeader
        className="elevated-card-tight-vertical !bg-indigo-300 !px-4 !py-3 row-between-center w-full"
        title="FOTO KENDARAAN"
        isBerangkat={isBerangkat}
        showBerangkat={showBerangkat}
        setShowBerangkat={setShowBerangkat}
      />
      <EditorMarkingRow
        {...common}
        titleName="TAMPAK DEPAN"
        labelGrup="gambar_depan"
      />
      <EditorMarkingRow
        {...common}
        titleName="TAMPAK BELAKANG"
        labelGrup="gambar_belakang"
      />
      <EditorMarkingRow
        {...common}
        titleName="TAMPAK KIRI"
        labelGrup="gambar_kiri"
      />
      <EditorMarkingRow
        {...common}
        titleName="TAMPAK KANAN"
        labelGrup="gambar_kanan"
      />

      {hasTrailer && (
        <>
          <EditorMarkingRow
            {...common}
            titleName="TAMPAK BOX DEPAN"
            labelGrup="gambar_box_depan"
          />
          <EditorMarkingRow
            {...common}
            titleName="TAMPAK BOX BELAKANG"
            labelGrup="gambar_box_belakang"
          />
          <EditorMarkingRow
            {...common}
            titleName="TAMPAK BOX KIRI"
            labelGrup="gambar_box_kiri"
          />
          <EditorMarkingRow
            {...common}
            titleName="TAMPAK BOX KANAN"
            labelGrup="gambar_box_kanan"
          />
        </>
      )}
    </>
  );
};

export default EditorFotoKendaraanSection;
